export interface Province {
  id: number;
  name: string;
}

export interface ProvincesResponse {
  data: Province[];
}

export type CitiesResponse = ProvincesResponse;

export interface ActivityCategory {
  id: number;
  title: string;
}

export interface ActivityCategoriesResponse {
  data: ActivityCategory[];
}

export enum CustomerType {
  Natural = 'natural',
  Legal = 'legal',
}

export enum Gender {
  Unknown,
  Male,
  Female,
}

export interface Profile {
  userName: string;
  nickName: string | undefined;
  firstName: string;
  lastName: string;
  gender: Gender | undefined;
  customerType: CustomerType;
  province: number;
  city: number | undefined;
  address: string | undefined;
  nationalCode: string;
  companyName: string;
  economicCode: string | undefined;
  haveEconomicCode: boolean;
  nationalId: string | undefined;
  phoneNumber: string | undefined;
  email: string | undefined;
  registrationNumber: string | undefined;
  postalCode: string | undefined;
  birthDate: number;
  activityCategory: number;
  activityCategoryTitle: string;
  mobileNumber: number | undefined;
  countryCode: string | undefined;
  countryCodeMobileNumber: string;
  occupation: string | undefined;
  avatar: string | undefined | null;
}

export type UpdateProfile = Omit<Profile, 'mobileNumber'>;

export type PatchProfile = Partial<Pick<Profile, 'avatar' | 'nickName' | 'occupation' | 'birthDate'>>;

export type MeResponse = Pick<Profile, 'userName' | 'firstName' | 'lastName' | 'avatar'>;

export interface ProfileResponse {
  data: Profile;
}

export interface ChangePasswordPayload {
  old_password: string;
  password: string;
  repeat_password: string;
  'g-recaptcha-response'?: string;
}

export interface ChangeMobileNumberPayload {
  mobile_number: string;
  country_code: string;
  code: string;
  'g-recaptcha-response'?: string;
}

export enum ExtraInformationStatusType {
  Trial = 'trial', // free user no paid service can change info at any time
  Changeable = 'changeable', // has paid service and the profile will be locked in 48 hours
  Complete = 'complete',
  Missing = 'missing', // has paid service and the profile is locked
}
